<template>
    <main id="home-wrapper">
        <div id="detail_photo">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url+'/', status: false },
                    { title: 'Gallery', url: app_url+'/gallery-photo', status: true },
                    {
                        title: detailPhoto
                            ? detailPhoto.title.length > 20
                                ? detailPhoto.title.substr(0, 20) + ' ...'
                                : detailPhoto.title
                            : 'Honda CBR 150R Custom...',
                        url: ' ',
                        status: true
                    }
                ]"
            ></breadcrumb>

            <section id="detail-article" class="section withPad">
                <div class="container">
                    <div class="row-detail-article">
                        <div class="inner_detail_article" v-if="detailPhoto">
                            <div class="main-title-article">
                                <h3>{{ detailPhoto.title }}</h3>
                                <span class="date-article">{{
                                    detailPhoto.date
                                }}</span>
                            </div>
                            <div class="slider_article">
                                <carousel
                                    :per-page="1"
                                    :mouse-drag="false"
                                    :navigationEnabled="true"
                                    :autoplay="true"
                                    :loop="true"
                                    navigationNextLabel='<i class="ion-chevron-right"></i>'
                                    navigationPrevLabel='<i class="ion-chevron-left"></i>'
                                >
                                    <slide
                                        v-for="(image,
                                        imgIndex) in detailPhoto.imageDetail"
                                        :key="imgIndex"
                                    >
                                        <div class="thumb_main_article">
                                            <img class="img-carousel" :src="image" @error="replaceByDefault" />
                                        </div>
                                    </slide>
                                </carousel>
                            </div>
                            <div class="text_article">
                                <p>
                                    <span
                                        v-html="detailPhoto.description"
                                    ></span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="related-article" class="section withPad">
                <div class="container">
                    <div class="section_title">
                        <h3>Related Photo</h3>
                    </div>
                    <div class="list_article">
                        <RelatedPhoto
                            url="/gallery-photo"
                            :relatedData="relatedPhoto"
                            @getRelatedData="getRelatedPhoto"
                        ></RelatedPhoto>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
import RelatedPhoto from "../news/RelatedPhoto";
import BreadCrumb from "../../widget/BreadCrumb";
import { isMobile } from "mobile-device-detect";
import { Carousel, Slide } from "vue-carousel";

export default {
    components: {
        Carousel,
        Slide,
        breadcrumb: BreadCrumb,
        RelatedPhoto
    },
    data() {
        return {
            base_url:base_url,
            app_url:app_url,
            api_url:api_url,
            mobile: false,
            detailPhoto: null,
            relatedPhoto: null
        };
    },
    created() {
        this.mobile = isMobile;
        this.getDetailPhoto();
    },
    methods: {
        replaceByDefault(event){
            event.target.src = base_url+'/images/default.jpg';
        },
        getDetailPhoto() {
            let route = api_url+`/photo-detail?slug=${this.$route.query.slug}`;
            axios
                .get(route)
                .then(res => {
                    console.log(res);
                    if (res.status == 200) {
                        if (res?.data?.status) {
                            this.detailPhoto = res?.data?.data?.detailPhoto;
                            if (this.detailPhoto) {
                                this.getRelatedPhoto();
                            }
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getRelatedPhoto() {
            let route = api_url+`/photo-related?except=${this.detailPhoto.id}`;
            if (this.relatedPhoto?.nextPageUrl) {
                route = this.relatedPhoto?.nextPageUrl;
            }
            axios
                .get(route)
                .then(res => {
                    console.log(res);
                    if (res.status == 200) {
                        if (res?.data?.status) {
                            this.relatedPhoto = res?.data?.data;
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
    }
};
</script>

<style scoped lang="scss">
.main-title-article {
    display: block;
    margin: 20px 0;
    h3 {
        font-weight: bold;
        font-size: 32px;
        color: #ffffff;
        margin: 0 0 0px 0;
    }
    .date-article {
        font-weight: 600;
        font-size: 12px;
        color: #b4b4b4;
    }
}
.slider_article,
.text_article {
    display: block;
    width: 100%;
    margin-bottom: 50px;
}
.thumb_main_article {
    display: block;
    overflow: hidden;
    border-radius: 10px;
    .img-carousel {
    //   object-fit: cover;

    }
    img {
        width: 100%;
    }
}
@media all and (max-width: 767px) {
    .main-title-article h3 {
        font-size: 24px;
    }
    .thumb_main_article {
      .img-carousel{
        height: 184px;
      }
    }
}
</style>
